import { render, staticRenderFns } from "./PdfPreviewComponent.vue?vue&type=template&id=62a7f2bb&lang=pug"
import script from "./PdfPreviewComponent.vue?vue&type=script&lang=ts"
export * from "./PdfPreviewComponent.vue?vue&type=script&lang=ts"
import style0 from "./PdfPreviewComponent.vue?vue&type=style&index=0&id=62a7f2bb&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('62a7f2bb')) {
      api.createRecord('62a7f2bb', component.options)
    } else {
      api.reload('62a7f2bb', component.options)
    }
    module.hot.accept("./PdfPreviewComponent.vue?vue&type=template&id=62a7f2bb&lang=pug", function () {
      api.rerender('62a7f2bb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/FileManager/Preview/components/PdfPreviewComponent/PdfPreviewComponent.vue"
export default component.exports